import './SectionHeading.css'

const SectionHeading = () => {

  return (
    <div className="section-heading text-center">
        <h2 className="title-head-subscribe" data-aos="fade-up">Don’t Miss ICO News And Updates!</h2>
        <p className="text-head-subscribe" data-aos="fade-up">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quis accumsan nisi Ut ut felis congue nisl hendrerit commodo.</p>
    </div>
  );
}

export default SectionHeading;